import { useSelector } from "react-redux";
import { Suspense, useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import SbLoading from "../../components/common/SbLoading";
import { initializeAmplitudeUser } from "../../utils/config/analytics";

const OnboardingRoute = ({ component: Component, ...rest }) => {
  const user = useSelector((state) => state.auth?.user);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  useEffect(() => {
    if (isAuthenticated) {
      initializeAmplitudeUser(user?.id, user);
      //   const obj = {
      //     id: user?.id,
      //     name: user?.name,
      //     email: user?.email,
      //     createdAt: user?.created_at,
      //     phone: user?.mobile?.number,
      //     country_code: user?.mobile?.country_code,
      //   };
      //   window.analytics.identify(user?.id, obj);
    }
  }, []);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (isAuthenticated) {
          window.dataLayer?.push({
            event: "gtm.load",
            pathname: props.location.pathname,
          });
          window.dataLayer?.push({
            event: "gtm.dom",
            pathname: props.location.pathname,
          });
          window.dataLayer?.push({
            event: "page_view",
            pathname: props.location.pathname,
          });
          return (
            <Suspense fallback={<SbLoading fullPage={true} />}>
              <Component {...props} />
            </Suspense>
          );
        } else {
          return <Redirect to="/login" />;
        }
      }}
    />
  );
};

export default OnboardingRoute;
